/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

export const inout_analog_read = (block, generator) => {
  const pin = block.getFieldValue('PIN') || '';
  // Siempre setups_: el pin viene de un dropdown y nunca es una variable.
  generator.setups_[`setup_green_analog_read${pin}`] = `pinMode(${pin},INPUT);\n`;
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const entradas_lluvia = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const entradas_suelo = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_photoresistor = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ENTRADAS_potentiometer = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

// entradas_sonido no es un analogRead directo: promedia 3 lecturas, acota a
// [175,300] y mapea a 0-1023, como el legacy.
const NOISE_FN = `
int getNormalizedNoise(int pin) {
  long suma = 0;
  for (int i = 0; i < 3; i++) {
    suma += analogRead(pin);
    delay(1);
  }
  int promedio = suma / 3;
  promedio = constrain(promedio, 175, 300);
  return map(promedio, 175, 300, 0, 1023);
}
`;

export const entradas_sonido = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.definitions_['entradas_sonido'] = NOISE_FN;
  generator.loop_[`entradas_sonido_${pin}`] = `int normalizado_${pin} = getNormalizedNoise(${pin});\n`;
  return [`normalizado_${pin}`, generator.ORDER_ATOMIC];
};
